var reviewForm = vueIfExists({
	el: '#review-form',
	data: {
		validFields: {
			recommend: null,
			recommend_platform: null
		},
		activeTab: 'review'
	},
	methods: {
		setTab: function(newTab) {
			var valid = null;
			if (newTab == 'submit') {
				valid = this.validateForm();
				if (valid) {
					this.activeTab = newTab;
				}
			} else {
				this.activeTab = newTab;
			}
			if (valid !== false) {
				$d.scrollto({ toElement: this.$refs['nav-tabs'], onlyUp: true });
			}
		},
		changeForm: function(event) {
			var name = event.target.getAttribute('name');
			if (name == 'recommend' || name == 'recommend_platform') {
				this.validateField(name);
			}
		},
		validateField: function(name) {
			var selected = false;
			var $els = document.querySelectorAll('[name="'+name+'"]');
			for (var i = 0; i < $els.length; i++) {
				if ($els[i].checked) selected = true;
			}
			this.validFields[name] = selected;
		},
		validateForm: function() {
			var $form = this.$el;
			this.validateField('recommend');
			this.validateField('recommend_platform');
			var $scrollTarget;
			if (!this.validFields.recommend) {
				this.activeTab = 'review';
				$d.scrollto({ toElement: this.$refs['recommend-question'] });
			} else if (!this.validFields.recommend_platform) {
				this.activeTab = 'review';
				$d.scrollto({ toElement: this.$refs['recommend-platform-question'] });			
			}
			return this.validFields.recommend && this.validFields.recommend_platform;
		},
		submit: function() {
			if (this.validateForm()) {
				this.$el.submit();
			}
		}
	}
});